// extracted by mini-css-extract-plugin
module.exports = {"cls1":"HomePage-CssProp3_th-module--cls1--114F8","cls2":"HomePage-CssProp3_th-module--cls2--340_G HomePage-CssProp3_th-module--cls1--114F8"};